import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Plans from './components/Plans';
import PlanSelection from './components/PlanSelection';
import SignUp from './components/SignUp';
import SignIn from './components/SignIn';
import BasicDashboard from './pages/BasicDashboard';
import PremiumDashboard from './pages/PremiumDashboard';
import EnterpriseDashboard from './pages/EnterpriseDashboard';
import './App.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const hideNavbar = location.pathname.includes('dashboard');
  return (
    <>
      {!hideNavbar && <Navigation />}
      <main className="main-content">{children}</main>
    </>
  );
};

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <Suspense fallback={<div className="loading">⏳ Loading...</div>}>
          <div className="App">
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/plan-selection" element={<PlanSelection />} />
                <Route path="/payment" element={<PlanSelection />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/basic-dashboard" element={<ProtectedRoute requiredPlan="basic"><BasicDashboard /></ProtectedRoute>} />
                <Route path="/dashboard/basic" element={<ProtectedRoute requiredPlan="basic"><BasicDashboard /></ProtectedRoute>} />
                <Route path="/premium-dashboard" element={<ProtectedRoute requiredPlan="premium"><PremiumDashboard /></ProtectedRoute>} />
                <Route path="/dashboard/premium" element={<ProtectedRoute requiredPlan="premium"><PremiumDashboard /></ProtectedRoute>} />
                <Route path="/enterprise-dashboard" element={<ProtectedRoute requiredPlan="enterprise"><EnterpriseDashboard /></ProtectedRoute>} />
                <Route path="/dashboard/enterprise" element={<ProtectedRoute requiredPlan="enterprise"><EnterpriseDashboard /></ProtectedRoute>} />
                <Route path="/dashboard" element={<Navigate to="/plans" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </div>
        </Suspense>
      </AuthProvider>
    </Router>
  );
}

export default App;
